(function () {
  if (window.__archiveLazyLoader) return;
  window.__archiveLazyLoader = true;

  const SECTION_ID = 'collection-archive-loader';

  // ---------------------------------------------------------------------------
  // Load a single collection on demand and open it
  // ---------------------------------------------------------------------------

  async function loadCollection(placeholder) {
    const handle = placeholder.dataset.collectionHandle;
    if (!handle) return;

    placeholder.classList.add('archive-cell-loading');

    try {
      const res = await fetch(`/collections/${handle}?sections=${SECTION_ID}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const html = data[SECTION_ID];
      if (!html) throw new Error('Empty section response');

      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newCell = temp.querySelector('.archive-cell');
      if (!newCell) throw new Error('No .archive-cell in response');

      placeholder.replaceWith(newCell);
      initArchiveCell(newCell);
      applyCurrentFilters(newCell);
      openCell(newCell);

    } catch (err) {
      console.error(`[archive-lazy-loader] Failed to load "${handle}":`, err);
      placeholder.classList.remove('archive-cell-loading');
    }
  }

  // ---------------------------------------------------------------------------
  // Attach click handlers to all placeholders
  // ---------------------------------------------------------------------------

  function init() {
    document.querySelectorAll('.archive-cell-placeholder').forEach((placeholder) => {
      placeholder.querySelector('.archive-cell-preview button')?.addEventListener('click', () => {
        loadCollection(placeholder);
      });
    });

    const requestedId = new URLSearchParams(window.location.search).get('collection');
    if (!requestedId) return;
    const target = document.querySelector(
      `.archive-cell-placeholder[data-id="${CSS.escape(requestedId)}"]`
    );
    if (target) loadCollection(target);
  }

  // ---------------------------------------------------------------------------
  // Event listener setup for a newly inserted archive cell
  // ---------------------------------------------------------------------------

  function openCell(cell) {
    document.querySelectorAll('.archive-cell').forEach((c) => c.classList.remove('archive-content-show'));
    cell.classList.add('archive-content-show');
    cell.scrollIntoView({ block: 'start' });
  }

  function initArchiveCell(cell) {
    // Toggle open / close
    cell.querySelector('.archive-cell-preview button')?.addEventListener('click', () => {
      if (cell.classList.contains('archive-content-show')) {
        cell.classList.remove('archive-content-show');
      } else {
        openCell(cell);
      }
    });

    // Slideshows
    cell.querySelectorAll('.contains-slideshow').forEach((slideshow) => {
      slideshow.querySelector('.trigger-slideshow')?.addEventListener('click', () => {
        slideshow.querySelector('.archive-slideshow')?.classList.add('slideshow-show');
      });
      slideshow.querySelector('.archive-slideshow-close')?.addEventListener('click', () => {
        slideshow.querySelector('.archive-slideshow')?.classList.remove('slideshow-show');
      });
      slideshow.querySelector('.archive-slideshow-previous')?.addEventListener('click', () => stepSlide(slideshow, -1));
      slideshow.querySelector('.archive-slideshow-next')?.addEventListener('click', () => stepSlide(slideshow, 1));
    });

    // Popups
    cell.querySelectorAll('.contains-popup').forEach((popupContainer) => {
      popupContainer.querySelector('.trigger-popup')?.addEventListener('click', () => {
        popupContainer.querySelector('.archive-popup')?.classList.add('popup-show');
      });
      popupContainer.querySelector('.archive-popup-close')?.addEventListener('click', () => {
        popupContainer.querySelector('.archive-popup')?.classList.remove('popup-show');
      });

      const multiPopup = popupContainer.closest('.contains-multiple-popup');
      const siblings = multiPopup?.querySelectorAll('.contains-popup');

      if (siblings && siblings.length > 1) {
        popupContainer.querySelector('.archive-popup-previous')?.addEventListener('click', () => stepPopup(multiPopup, popupContainer, -1));
        popupContainer.querySelector('.archive-popup-next')?.addEventListener('click', () => stepPopup(multiPopup, popupContainer, 1));
      } else {
        popupContainer.querySelector('.archive-popup-previous')?.remove();
        popupContainer.querySelector('.archive-popup-next')?.remove();
      }
    });

    // Audio on hover
    cell.querySelectorAll('[data-audio]').forEach((el) => {
      el.addEventListener('mouseenter', () => {
        const audioEl = document.createElement('audio');
        audioEl.src = el.getAttribute('data-audio');
        audioEl.type = 'audio/mp3';
        el.appendChild(audioEl);
        audioEl.play();
        audioEl.addEventListener('ended', () => audioEl.remove());
      });
    });

    // Feature/title pulsing
    cell.querySelectorAll('.feature-preview').forEach((feature) => {
      feature.addEventListener('mouseover', () => {
        const h = feature.getAttribute('data-archive-title');
        document.querySelectorAll(`.title-pulsing-${h}`).forEach((el) => el.classList.add('pulsing'));
      });
      feature.addEventListener('mouseout', () => {
        const h = feature.getAttribute('data-archive-title');
        document.querySelectorAll(`.title-pulsing-${h}`).forEach((el) => el.classList.remove('pulsing'));
      });
    });

    cell.querySelectorAll('.archive-title').forEach((title) => {
      title.addEventListener('mouseover', () => {
        const h = title.getAttribute('data-archive-image');
        document.querySelectorAll(`.image-pulsing-${h}`).forEach((el) => el.classList.add('pulsing'));
      });
      title.addEventListener('mouseout', () => {
        const h = title.getAttribute('data-archive-image');
        document.querySelectorAll(`.image-pulsing-${h}`).forEach((el) => el.classList.remove('pulsing'));
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Apply the archive filter state to a newly inserted cell
  // ---------------------------------------------------------------------------

  function applyCurrentFilters(cell) {
    const activeFilters = Array.from(
      document.querySelectorAll('.archive-menu .filter.filter-active')
    ).map((f) => f.getAttribute('data-filter')).filter(Boolean);

    const allFilters = Array.from(
      document.querySelectorAll('.archive-menu .filter')
    ).map((f) => f.getAttribute('data-filter')).filter(Boolean);

    const filtersToApply = activeFilters.length > 0 ? activeFilters : allFilters;

    cell.querySelectorAll('.archive-col[data-filter]').forEach((col) => {
      col.classList.toggle('column-active', filtersToApply.includes(col.getAttribute('data-filter')));
    });
  }

  // ---------------------------------------------------------------------------
  // Slide / popup helpers
  // ---------------------------------------------------------------------------

  function stepSlide(slideshow, direction) {
    const slides = slideshow.querySelectorAll('.slide');
    const current = Array.from(slides).findIndex((s) => s.classList.contains('show'));
    if (current === -1) return;
    slides[current].classList.remove('show');
    let next = current + direction;
    if (next < 0) next = slides.length - 1;
    if (next >= slides.length) next = 0;
    slides[next].classList.add('show');
  }

  function stepPopup(multiPopup, currentContainer, direction) {
    const containers = multiPopup.querySelectorAll('.contains-popup');
    const currentIndex = Array.from(containers).indexOf(currentContainer);
    currentContainer.querySelector('.archive-popup')?.classList.remove('popup-show');
    let next = currentIndex + direction;
    if (next < 0) next = containers.length - 1;
    if (next >= containers.length) next = 0;
    containers[next].querySelector('.archive-popup')?.classList.add('popup-show');
  }

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
